const disconnectMigration = (state) => {
  return {
    ...state,
    auth: {
      ...state.auth,
      // JWT token format changed, prevent errors and just log out users on this migration
      access_token: null,
    }
  };
};

export default disconnectMigration;
